import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=d5dfffc4&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dfffc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5dfffc4')) {
      api.createRecord('d5dfffc4', component.options)
    } else {
      api.reload('d5dfffc4', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=d5dfffc4&scoped=true&", function () {
      api.rerender('d5dfffc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xETtb8O3pxFO/JS/comp/Voucher-Unit.vue"
export default component.exports